module.exports = __webpack_public_path__ + "static/adeosun-79883fd29eee07f26ffbfbd9b02b7c41.jpg";